import { fetchApi } from "../utils/fetchApi";

export function fetchCharts({ filter = {}, options = {} }) {
  return fetchApi({ url: 'charts/charginginsights', filter, options });
}

